import { render, staticRenderFns } from "./GoodsStore.vue?vue&type=template&id=4701cef5&scoped=true&"
import script from "./GoodsStore.vue?vue&type=script&lang=js&"
export * from "./GoodsStore.vue?vue&type=script&lang=js&"
import style0 from "./GoodsStore.vue?vue&type=style&index=0&id=4701cef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701cef5",
  null
  
)

export default component.exports